import * as React from "react";
import { SpsModal, SpsModalBody, SpsModalFooter, SpsModalAction, SpsCard, SpsButton } from "../index";
import { ButtonKind } from "@spscommerce/ds-shared";
export const SpsModalPropTypes = SpsModal["propTypes"];

function SpsModalFunctionalExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);
    const [size, setSize] = React.useState("default");

    function openModal(modalSize: any) {
        if (modalSize) {
            setSize(modalSize);
        }
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"Basic_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
                size={size}
                data-testid={testId}
            >
                <SpsModalBody>"This is the body of small modal"</SpsModalBody>
                <SpsModalFooter />
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal("small");
                }}
                data-testid={`${testId}__button`}
            >
                Small Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("default");
                }}
            >
                Default Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("large");
                }}
            >
                Large Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalFunctionalExample.reactLive = {
    code: `
    function Component () {

        var smallModal;
        const [open, setOpen] = React.useState(false);
        const [size, setSize] = React.useState("default");

        function openModal(size){
            if(size) setSize(size);
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"Basic_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                    size={size}
                >
                    <SpsModalBody>"This is the body of small modal"</SpsModalBody>
                    <SpsModalFooter />
                </SpsModal>
                <SpsButton onClick={e=>{openModal('small')}}>Small Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('default')}}>Default Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('large')}}>Large Modal</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalKindsExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);
    const [kind, setKind] = React.useState("default");

    function openModal(modalKind) {
        if (modalKind) {
            setKind(modalKind);
        }
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={kind}
                id={"Basic_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
            >
                <SpsModalBody>"This is the body of small modal"</SpsModalBody>
                <SpsModalFooter />
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal("success");
                }}
            >
                Success Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("warning");
                }}
            >
                Warning Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("delete");
                }}
            >
                Delete Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("info");
                }}
            >
                Info Modal
            </SpsButton>
            <SpsButton
                onClick={e => {
                    openModal("tip");
                }}
            >
                Tip Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalKindsExample.reactLive = {
    code: `
    function Component () {

        var smallModal;
        const [open, setOpen] = React.useState(false);
        const [kind, setKind] = React.useState("default");

        function openModal(modalKind){
            if(modalKind) setKind(modalKind);
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={kind}
                    id={"Basic_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                >
                    <SpsModalBody>"This is the body of small modal"</SpsModalBody>
                    <SpsModalFooter />
                </SpsModal>
                <SpsButton onClick={e=>{openModal('success')}}>Success Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('warning')}}>Warning Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('delete')}}>Delete Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('info')}}>Info Modal</SpsButton>
                <SpsButton onClick={e=>{openModal('tip')}}>Tip Modal</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalActionExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);
    const [num, setNum] = React.useState(0);

    function openModal() {
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    function increment() {
        setNum(number => number + 1);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"increment_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
            >
                <SpsModalBody>"This is the body of modal"</SpsModalBody>
                <SpsModalFooter>
                    <SpsModalAction kind={ButtonKind.DEFAULT}>Cancel</SpsModalAction>
                    <SpsModalAction
                        kind={ButtonKind.CONFIRM}
                        onClick={() => {
                            increment();
                        }}
                    >
                        Increase
                    </SpsModalAction>
                </SpsModalFooter>
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal();
                }}
            >
                Open "{num}"
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalActionExample.reactLive = {
    code: `
    function Component () {

        const [open, setOpen] = React.useState(false);
        const [num, setNum] = React.useState(0);

        function openModal(){
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        function increment() {
            setNum(num => num + 1);
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"increment_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                >
                    <SpsModalBody>"This is the body of modal"</SpsModalBody>
                    <SpsModalFooter>
                        <SpsModalAction kind="default">Cancel</SpsModalAction>
                        <SpsModalAction
                          kind="confirm"
                          onClick={() => {
                            increment();
                          }}
                        >
                          Increase
                        </SpsModalAction>
                    </SpsModalFooter>
                </SpsModal>
                <SpsButton onClick={e=>{openModal()}}>Open "{num}"</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalActionRequiredExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);

    function openModal() {
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"increment_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
                actionRequired={true}
            >
                <SpsModalBody>"This is the body of modal"</SpsModalBody>
                <SpsModalFooter>
                    <SpsModalAction kind={ButtonKind.DEFAULT}>Cancel</SpsModalAction>
                    <SpsModalAction kind={ButtonKind.KEY}>Ok</SpsModalAction>
                </SpsModalFooter>
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal();
                }}
            >
                Open Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalActionRequiredExample.reactLive = {
    code: `
    function Component () {

        const [open, setOpen] = React.useState(false);

        function openModal(){
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"increment_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                    actionRequired={true}
                >
                    <SpsModalBody>"This is the body of modal"</SpsModalBody>
                    <SpsModalFooter>
                        <SpsModalAction kind="default">Cancel</SpsModalAction>
                        <SpsModalAction kind="key">Ok</SpsModalAction>
                    </SpsModalFooter>
                </SpsModal>
                <SpsButton onClick={e=>{openModal()}}>Open Modal</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalStayOpenExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);

    function openModal() {
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"increment_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
                actionRequired={true}
            >
                <SpsModalBody>"This is the body of modal"</SpsModalBody>
                <SpsModalFooter>
                    <SpsModalAction kind={ButtonKind.DEFAULT}>Cancel</SpsModalAction>
                    <SpsModalAction kind={ButtonKind.KEY} onClick={() => false}>Ok</SpsModalAction>
                </SpsModalFooter>
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal();
                }}
            >
                Open Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalStayOpenExample.reactLive = {
    code: `
    function Component () {

        const [open, setOpen] = React.useState(false);

        function openModal(){
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"increment_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                    actionRequired={true}
                >
                    <SpsModalBody>"This is the body of modal"</SpsModalBody>
                    <SpsModalFooter>
                        <SpsModalAction kind="default">Cancel</SpsModalAction>
                        <SpsModalAction kind="key" onClick={() => false}>Ok</SpsModalAction>
                    </SpsModalFooter>
                </SpsModal>
                <SpsButton onClick={e=>{openModal()}}>Open Modal</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalAsyncActionExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);

    function openModal() {
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"increment_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
            >
                <SpsModalBody>"This is the body of modal"</SpsModalBody>
                <SpsModalFooter>
                    <SpsModalAction kind={ButtonKind.DEFAULT}>Cancel</SpsModalAction>
                    <SpsModalAction
                        kind={ButtonKind.KEY}
                        onClick={() => {
                            return new Promise(resolve => {
                                window.setTimeout(resolve, 3000);
                            });
                        }}
                    >
                        Action for 3s
                    </SpsModalAction>
                </SpsModalFooter>
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal();
                }}
            >
                Open Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalAsyncActionExample.reactLive = {
    code: `
    function Component () {

        const [open, setOpen] = React.useState(false);

        function openModal(){
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"increment_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                >
                    <SpsModalBody>"This is the body of modal"</SpsModalBody>
                    <SpsModalFooter>
                        <SpsModalAction kind="default">Cancel</SpsModalAction>
                        <SpsModalAction kind="key" onClick={() => {
                            return new Promise(resolve => {
                              window.setTimeout(resolve, 3000);
                            });
                          }}
                        >Action for 3s</SpsModalAction>
                    </SpsModalFooter>
                </SpsModal>
                <SpsButton onClick={e=>{openModal()}}>Open Modal</SpsButton>
            </SpsCard>
        );
    }
    render(<Component />)
    `
};

function SpsModalwithInputExample(props) {
    // A demo-able representation of this example
    const { "data-testid": testId } = props;
    const [open, setOpen] = React.useState(false);

    function openModal() {
        setOpen(s => !s);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <SpsCard>
            <SpsModal
                kind={"default"}
                id={"increment_modal"}
                isOpen={open}
                header="This is modal header"
                onClose={handleClose}
            >
                <SpsModalBody>"This is the body of modal"</SpsModalBody>
                <SpsModalFooter>
                    <SpsModalAction kind={ButtonKind.DEFAULT}>Cancel</SpsModalAction>
                    <SpsModalAction
                        kind={ButtonKind.KEY}
                        onClick={() => {
                            return new Promise(resolve => {
                                window.setTimeout(resolve, 3000);
                            });
                        }}
                    >
                        Action for 3s
                    </SpsModalAction>
                </SpsModalFooter>
            </SpsModal>
            <SpsButton
                onClick={e => {
                    openModal();
                }}
            >
                Open Modal
            </SpsButton>
        </SpsCard>
    );
}

// @ts-ignore
SpsModalwithInputExample.reactLive = {
    code: `
    function Component () {

        const [open, setOpen] = React.useState(false);
        const [name, setName] = React.useState('');
        const [welcome, setWelcome] = React.useState('');

        function openModal(){
            setOpen(s=> !s);
        }

        function handleClose() {
            setOpen(false)
        }

        function changeHandler(e) {
            setName(e.target.value);
        }

        function submit() {
            setWelcome(name);
            setName('');
        }

        return (
            <SpsCard>
                <SpsModal
                    kind={'default'}
                    id={"increment_modal"}
                    isOpen={open}
                    header="This is modal header"
                    onClose={handleClose}
                >
                    <SpsModalBody>
                        <div className="row">
                            <div className="col-sm-4">Please enter your name :</div>
                            <div className="col-sm-8">
                                <input
                                  className="sps-form-control"
                                  value={name}
                                  placeholder
                                  onChange={changeHandler}
                                />
                            </div>
                        </div>
                    </SpsModalBody>
                    <SpsModalFooter>
                        <SpsModalAction kind="default">Cancel</SpsModalAction>
                        <SpsModalAction kind="key" onClick={submit}>
                          Submit
                        </SpsModalAction>
                    </SpsModalFooter>
                </SpsModal>
                <SpsButton onClick={e=>{openModal()}}>Open Modal</SpsButton>
                <br />
                {welcome && <p>Hi {welcome}</p>}
            </SpsCard>
        );
    }
    render(<Component />)
    `
};
export {
    SpsModalFunctionalExample,
    SpsModalKindsExample,
    SpsModalActionExample,
    SpsModalActionRequiredExample,
    SpsModalStayOpenExample,
    SpsModalAsyncActionExample,
    SpsModalwithInputExample
};
